<template>
  <div class="modal fade" tabindex="-1" role="dialog" id="show-email-modal">
    <div class="modal-dialog" role="document">
      <loading-spinner v-if="loading" style="margin: 30px"></loading-spinner>

      <div v-else class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">
              &times;
            </span>
          </button>

          <h4 class="modal-title">
            {{ email.attributes.subject }}
          </h4>
        </div>

        <div class="modal-body">
          <iframe :srcdoc="content" style="width: 100%; height: 500px; border: none;"></iframe>

          <hr>

          <div v-if="email.attributes.attachments.length">
            <h4>
              Attachments
            </h4>

            <ul>
              <li v-for="attachment in email.attributes.attachments">
                <a :href="'/api/v2/attachments/' + attachment.id + '/content?token=' + shared.token">
                  {{ attachment.name }}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-default" data-dismiss="modal">
            Close
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import http from '@/http'
import store from '@/store'
import LoadingSpinner from '@/components/Layout/LoadingSpinner'

export default {
  components: {LoadingSpinner},

  props: {
    email: {
      required: false,
      type: Object
    }
  },

  data() {
    return {
      content: null,
      loading: true,
      shared: store
    }
  },

  watch: {
    email() {
      this.loading = true

      http.get('/api/v2/emails/' + this.email.id + '/content')
          .then(response => {
            this.content = response.data.data.attributes.value

            this.loading = false
          })
    }
  }
}
</script>
